import Logo2 from "../../assets/navbar/logo.svg";
import React, { useState, useEffect, useRef } from "react";
import "../homepage/homepage.css";
import { useNavigate } from "react-router";
import "./auth.css";
import SubmitIcon from "../../assets/contactus/submit.svg";
import { ApiHelper } from "../../utilFunctions/utilfunction";
import { useForm } from "react-hook-form";
import { useParams } from "react-router";
import { Eye, EyeOff } from "lucide-react";
export const ResetPassword = () => {
    const { id: user_id, token } = useParams();
    const [loading, setLoading] = useState(false);
    const [banner, setBanner] = useState();
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [isError, setIsError] = useState(false);
    const togglePassword = () => setShowPassword((prev) => !prev);
    const toggleConfirmPassword = () => setShowConfirmPassword((prev) => !prev);
    const [flashmessage, setFlashmessage] = useState(false);

    const [messagess, setMessagess] = useState("");

    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
        trigger,
        watch,
    } = useForm();

    const Submit = async (data) => {
        const reqToSend = {
            user_id, // from params
            token, // from params
            password: data.password,
            password_confirmation: data.password_confirmation,
        };
        setLoading(true)
        try {
            const response = await ApiHelper("/reset-password", reqToSend, "POST");

            if (response?.status === true) {
                setIsError(false);
                setMessagess("Password reset successful!");
                setFlashmessage(true);
                setTimeout(() => {
                    setFlashmessage(false);
                    setMessagess("");
                    reset()

                    navigate("/login");

                }, 1000);

            } else {
                const errorMsg = response?.message || "Rest Password link sent failed.";

                setIsError(true);
                setMessagess(errorMsg);
                setFlashmessage(true);

                setTimeout(() => {
                    setFlashmessage(false);
                    setMessagess("");
                    setIsError(false);

                }, 10000);
            }
        } catch (error) {
            setMessagess("Something went wrong.");
            setFlashmessage(true);
            setTimeout(() => {
                setFlashmessage(false);
                setMessagess("");
                setIsError(false);

            }, 10000);
        } finally {
            setLoading(false)
        }

        reset();
    };

    const navigate = useNavigate();
    useEffect(async () => {
        let url = "/banner";
        let bannerdata = await ApiHelper(url);
        setBanner(bannerdata);
    }, []);
    return (
        <section className="mainhomepage">
            <div className="wholepopup d-flex justify-content-center align-items-center w-100">
                <div className="container d-flex flex-column back_image_color flex-md-row align-items-center ps-lg-0 pe-lg-0 mb-5 position-relative">
                    {banner && banner.data.length ? (
                        <div className="col-12 col-md-6">
                            {banner.data.map((value, index) => (
                                <img
                                    key={index}
                                    className="for_height mw-100 w-100"
                                    src={value ? value.image_path : ""}
                                    alt="image"
                                />
                            ))}
                        </div>
                    ) : (
                        <div className="col-12 col-md-6"></div>
                    )}

                    <div className="col-12 col-md-6">
                        <div
                            className="rightside_content d-flex justify-content-center align-items-center"
                            style={{ background: "#f0f0f0" }}
                        >
                            <div className="d-flex flex-column responsive-contianer flex-grow-1 align-items-center">
                                <img className="logo2_bottom" src={Logo2} alt="logo" />
                                <h2
                                    className=" text-center fw-bold responsive-heading"
                                >
                                    Reset Password
                                </h2>
                                <form className="form w-100" onSubmit={handleSubmit(Submit)}>
                                    <div className="d-flex flex-column login-form w-100">
                                        <p
                                            className="text-center "
                                          style={{ fontSize:'18px'}}
                                        >
                                            Please enter a new password to reset the password on your
                                            account.
                                        </p>
                                        <div className="textOnInput ">
                                            <input
                                                className="form-control"
                                                type={showPassword ? "text" : "password"}
                                                {...register("password", {
                                                    required: "Password is required",
                                                })}
                                            />
                                            <span
                                                onClick={togglePassword}
                                                className="position-absolute end-0 translate-middle-y me-3 cursor-pointer"
                                                style={{ top: errors.password ? '33%' : '50%', }}

                                            >
                                                {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                                            </span>
                                            {errors.password && (
                                                <p className="text-danger small mb-0">{errors.password.message}</p>
                                            )}
                                            <label htmlFor="password">New Password*</label>
                                        </div>

                                        <div className="textOnInput "   {...(flashmessage? { style: { marginBottom: 20 } } : {})}>
                                            <input
                                                className="form-control"
                                                type={showConfirmPassword ? "text" : "password"}
                                                {...register("password_confirmation", {
                                                    required: "Please confirm your password",
                                                    validate: (value) =>
                                                        value === watch("password") || "Passwords do not match",
                                                })}
                                            />
                                            <span
                                                onClick={toggleConfirmPassword}
                                                className="position-absolute end-0 translate-middle-y me-3 cursor-pointer"
                                                style={{ top: errors.password_confirmation ? '33%' : '50%', }}
                                            >
                                                {showConfirmPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                                            </span>
                                            {errors.password_confirmation && (
                                                <p className="text-danger small mb-0">{errors.password_confirmation.message}</p>
                                            )}
                                            <label htmlFor="password_confirmation">Confirm Password*</label>
                                        </div>
                                        {loading && (
                                            <div className="spinner-border text-light align-self-center" style={{
                                                width: "1.5rem",
                                                height: "1.5rem",
                                                borderWidth: "0.2em",
                                                borderColor: "#ccc", // All borders
                                                borderTopColor: "#333", // Spinner color
                                            }} role="status">
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                        )}
                                        {flashmessage && messagess && (
                                                  <div
                                                  className={`d-flex mt-1 align-items-center pt-2 pt-sm-0 ${
                                                    isError ? "text-danger" : "text-black"
                                                  }`}
                                                  style={{marginBlock:'5px'}}
                                                >
                                                  {!isError && (
                                                    <img className=" pe-2" src={SubmitIcon} alt="" />
                                                  )}
                                                  <span className="fs-5">
                                                      {messagess}
                                                  </span>
                                                </div>
                                            )}


                                        <div className="d-flex justify-content-between gap-4">
                                            <button
                                                type="button"
                                                style={{
                                                    width: "150px",
                                                    fontSize: "18px",
                                                    fontWeight: "bold",
                                                    fontFamily: "Times New Roman",
                                                    background: "transparent",
                                                    border: "2px solid #000",
                                                    borderRadius: "7px",
                                                    color: "#000",
                                                }}
                                                onClick={() => navigate(-1)} // or your cancel logic
                                            >
                                                Cancel
                                            </button>
                                            <button
                                                type="submit"
                                                className="auth-button"
                                                style={{
                                                    width: "150px",
                                                    fontSize: "18px",
                                                    fontWeight: "bold",
                                                    fontFamily: "Times New Roman",
                                                }}
                                            >
                                                Submit
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};
